export default {
    showStatusReport: 'Statusreport anzeigen'
};